import React, { useState, useEffect } from 'react';
import MultiListPopUpAs from '../atoms/MultiListPopUpAs';

function FromMoveListAs(props) {
    const handleClose = () => {
        props.setShowPopUpAs(false);
        window.location.reload();  // Refresh page on close
    };
    return (
        <div className="row form-fields">
            <div className="label col-6">
                <label></label>
            </div>
            <div className="item col-6">
                <button
                    onClick={() => { props.setShowPopUpAs(true); }}
                    className="btn btn-primary mb-2">
                    Continue <span className="bi bi-gear-fill"></span>
                </button>

                <MultiListPopUpAs
                    titleAs={props.labelAs}
                    showAs={props.showPopUpAs}
                    showsetterAs={handleClose}
                    dataAs={props.dataAs}
                    datasetterAs={props.datasetterAs}
                    setLoadingAs={props.setLoadingAs}   // pass loader setter
                    setProgress={props.setProgress}     // pass progress setter
                    setTotal={props.setTotal}           // pass total setter
                />
            </div>
        </div>
    )
}

export default FromMoveListAs